import { useContext } from 'react'

import { ROUTES } from '@/constants/routes'

import { AuthContext } from '@/contexts/AuthContext'

import BottomTabNavigation from '@/components/BottomTabNavigation'

const TABS = [
  { id: 'home', icon: 'home', label: 'Home', route: ROUTES.DASHBOARD },
  { id: 'history', icon: 'history', label: 'History', route: ROUTES.HISTORY },
  { id: 'profile', icon: 'profile', label: 'Profile', route: ROUTES.PROFILE }
]

export default function WithBottomNavLayout({ children }) {
  const { isUserLoggedIn } = useContext(AuthContext)
  return (
    <>
      {children}
      {isUserLoggedIn ? <BottomTabNavigation tabs={TABS} /> : null}
    </>
  )
}
